import React from 'react';

const DefaultHeaderContext = React.createContext({
  toggleFullWidthSearch: null,
  searchInFullWidth: false,
});

export default DefaultHeaderContext;
